import { Injectable } from '@angular/core';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';

@Injectable()
export class InputDatepickerService {

    private currentLanguage: string = 'es-ES'; //Spanish language by default.

    public sectionView: any = [
          {provide: MAT_DATE_LOCALE, useValue: this.currentLanguage},
          {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
          {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
        ];

    constructor() { }

    getInternationalization(){
        return this.currentLanguage;
    }

    setInternationalization(languageCode){
        return this.currentLanguage = languageCode;
    }
}
